export default __webpack_public_path__ + "static/media/404.16c88300.gif";